import axios from 'axios';
import { ArgsGetCompanies } from '~/types/companies';

const getCompanies = async (params: ArgsGetCompanies) => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/companies`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data;
};

const createCompany = async (payload: {
  name: string,
  type: string,
  exhibitions?: string[],
}) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/companies`,
    payload,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data;
};

const updateCompany = async (
  id: string,
  payload: {
    name?: string,
    type?: string,
    code?: string,
    activities?: string[],
    thematics?: string[],
    contact?: Record<string, unknown> | null,
    address?: Record<string, unknown>,
    exhibitions?: string[],
  },
) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.put(
    `${process.env.REACT_APP_API_URL}/companies/${id}`,
    payload,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data;
};

const getTop5 = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/companies/top5`,
  );
  return data?.providers;
};

const getCompany = async (id: string) => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/companies/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.company;
};

const getCompaniesList = async (params: { type?: string }) => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/companies/list`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data?.list;
};

export {
  getTop5,
  getCompanies,
  getCompany,
  getCompaniesList,
  createCompany,
  updateCompany,
};
